var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { FORM_ERROR } from 'final-form';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { apiUpdateUserPasswordReset } from '@/actions/PasswordActionsTs';
import { RouterLink } from '@/components/functional/Link/RouterLink';
import { PasswordResetEditView, PASSWORD_RESET_EDIT_REQUEST_TYPE_SETTING, PASSWORD_RESET_EDIT_REQUEST_TYPE_RESET, } from '@/components/pages/password/PasswordResetEditView';
import { LinkText } from '@/components/ui/Typography/Body/LinkText';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { BAD_RESET_TOKEN_EXPIRED } from '@/utils/constants/api/responseCode';
import { passwordResetPath, passwordResetCompletePath, passwordSettingComplete, } from '@/utils/router/links';
/**
 * パスワード再設定
 */
export const PasswordResetEditPage = (props) => {
    var _a;
    const { match } = props;
    const history = useNavigate();
    const token = ((_a = match === null || match === void 0 ? void 0 : match.params) === null || _a === void 0 ? void 0 : _a.token) || '';
    const path = (match === null || match === void 0 ? void 0 : match.url) || '';
    const dispatch = useDispatch();
    const { redirectCompletePath, requestType } = useMemo(() => {
        const isReset = path.indexOf(passwordResetPath()) >= 0;
        const type = isReset
            ? PASSWORD_RESET_EDIT_REQUEST_TYPE_RESET
            : PASSWORD_RESET_EDIT_REQUEST_TYPE_SETTING;
        return {
            redirectCompletePath: isReset
                ? passwordResetCompletePath()
                : passwordSettingComplete(),
            requestType: type,
        };
    }, [path]);
    /**
     * パスワード再設定処理
     */
    const resetPassword = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        const data = {
            json: { password: values.password },
            path: { token },
        };
        const action = apiUpdateUserPasswordReset(data, {});
        yield wrapDispatch(dispatch, action);
        // パスワード再設定 成功時（完了画面遷移）
        history.push(redirectCompletePath);
    }), [dispatch, history, redirectCompletePath, token]);
    /**
     * パスワード再設定失敗時の処理
     * @param errorObject
     */
    const resetPasswordErrorCallback = useCallback(({ exception }) => {
        var _a, _b;
        const isTokenError = ((_b = (_a = exception === null || exception === void 0 ? void 0 : exception.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code) === BAD_RESET_TOKEN_EXPIRED;
        const tokenErrorMessage = {
            [FORM_ERROR]: (_jsxs(_Fragment, { children: ["\u3053\u306EURL\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u518D\u8A2D\u5B9A\u3067\u304D\u307E\u305B\u3093\u3002", _jsx(RouterLink, Object.assign({ className: 'group', to: passwordResetPath() }, { children: _jsx(LinkText, Object.assign({ isGroup: true, size: 'sm' }, { children: "\u3053\u3061\u3089" })) })), "\u304B\u3089URL\u3092\u518D\u767A\u884C\u3057\u3066\u304F\u3060\u3055\u3044"] })),
        };
        return isTokenError ? tokenErrorMessage : undefined;
    }, []);
    return (_jsx(PasswordResetEditView, { customErrorCallback: resetPasswordErrorCallback, onSubmit: resetPassword, requestType: requestType }));
};
